import React from 'react';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { clientStore } from 'apps/client/app';
import { CommunityPage } from 'apps/home/community';
import CommunityTopics from 'apps/home/community/topics';
import { themes } from 'styles/themes/wikifactoryNew';
import CommunityFeatured from 'apps/home/community/featured';
import CommunityProjects from 'apps/home/community/projects';
import CommunityTasks from 'apps/home/community/tasks';
import { FloatingTabs, FloatingTab } from 'components';

const viewsMap = {
  '': CommunityPage,
  featured: CommunityFeatured,
  topics: CommunityTopics,
  projects: CommunityProjects,
  tasks: CommunityTasks,
};

const CommunityTabsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

const CommunitySpace = withNamespaces()(
  observer(props => {
    const View = props.componentFromRoute();
    const { route, routerStore } = props;
    const is404 = View === FourOhFour;
    const shouldShowCommunityTabs =
      Boolean(clientStore.signedInProfile) && !is404;

    const floatingTabStyle = {
      padding: '0.25rem 1rem',
      margin: '0 0.25rem',
      color: themes.color.wfBlack,
    };

    return (
      <>
        {shouldShowCommunityTabs && (
          <CommunityTabsWrapper>
            <FloatingTabs
              value={route.name}
              onClick={(event, value) => {
                routerStore.navigate(value);
              }}
            >
              <FloatingTab
                style={floatingTabStyle}
                value='home.community.featured'
              >
                Featured
              </FloatingTab>
              <FloatingTab
                style={floatingTabStyle}
                value='home.community.topics'
              >
                Topics
              </FloatingTab>
              <FloatingTab
                style={floatingTabStyle}
                value='home.community.projects'
              >
                Projects
              </FloatingTab>
              <FloatingTab
                style={floatingTabStyle}
                value='home.community.tasks'
              >
                Tasks
              </FloatingTab>
            </FloatingTabs>
          </CommunityTabsWrapper>
        )}
        <View params={props.params} />
      </>
    );
  }),
);

CommunitySpace.propTypes = {
  routerStore: PropTypes.object,
  route: PropTypes.object,
  componentFromRoute: PropTypes.func,
  params: PropTypes.object,
};

export const CommunityRouter = routeNode(
  'home.community',
  viewsMap,
  FourOhFour,
)(CommunitySpace);
